var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{ref:"modal",attrs:{"loading":true,"width":"800","mask-closable":false},on:{"on-ok":_vm.onOk,"on-cancel":_vm.onCancel},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}})}
var staticRenderFns = []

export { render, staticRenderFns }